<template>
    <div>
        <base-view :busy="busy"
                   @filter="filter">
            <vx-card>
                <vs-tabs position="top" class="tabs-shadow-none" id="profile-tabs" v-model="activeTab" >
                    <vs-tab icon-pack="feather" icon="icon-check" label="Concluídos">

                       <BillDataTable :bills="bills" 
                                      @selected="openModalBill"
                                      :limit="limit"/>

                    </vs-tab>
                    <!-- <vs-tab icon-pack="feather" icon="icon-package" label="Delivery">
                    </vs-tab> -->
                    <vs-tab icon-pack="feather" icon="icon-x-circle" label="Cancelados">
                        <BillDataTable :bills="archievedBills" 
                                       @selected="openModalBill"
                                       :limit="limit"/>
                    </vs-tab>
                </vs-tabs>
            </vx-card>
        </base-view>
        <modal-users-orders 
            :viewOnly="true"
            :visible="modalBill.visible"
            :table="modalBill.table"
            @close="(value) => modalBill.visible = value"
        />
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import hash from '../../hash';
    import ModalUsersOrders from '@/components/bill/ModalUsersOrders'
    import BaseView from '../BaseView.vue'
    import BillDataTable from './BillDataTable.vue'

    export default {
        components : {
            ModalUsersOrders,
            BaseView,
            BillDataTable
        },

        watch: {
            activeTab (value) {
                this.update(value);
            }
        },

        data () {
            return {
                selected : [],
                bills : [],
                archievedBills: [],
                periodFilter : {
                    from: '',
                    to: ''
                },
                modalBill : {
                    visible : false,
                    table : {}
                },
                activeTab: 0,
                tabConfig: {
                    0: { loaded: false, listener: 'billListener', coisa: 'bills', action: 'getBills', },
                    // 1: { loaded: false, coisa: 'bills', action: '', },
                    1: { loaded: false, listener: 'archiveListener', coisa: 'archievedBills', action: 'getArchiveBills', },
                },
                busy: false,
                limit: 100,
                billListener: null,
                archiveListener: null,
            }
        },

        methods : {
            async openModalBill (tr) {
                let table = this.bills.find(a => a.id == tr.id) || this.archievedBills.find(a => a.id == tr.id)
                if (!table)
                    return;
                this.modalBill = {
                    visible : true,
                    table : table
                }
            },
            
            async getBills () {
                let companyId = this.$store.getters.getCompanyID
                const firestore = firebase.firestore();
                let bills = firestore.collection('company').doc(companyId).collection('bill')
                                                          .orderBy('openedOn', 'desc')
                                                          .where('isClosed', '==', true)
                                                          .where('openedOn', '>=', this.periodFilter.from)
                                                          .where('openedOn', '<=', this.periodFilter.to)
                                                        //   .where('id', '==', 'VcEtw05PewYfZAGyON6Q')
                                                          .limit(this.limit)
                this.billListener = bills.onSnapshot((snapshot) => {
                    snapshot.docChanges().forEach(change => {
                        if (change.type === "added") {
                            this.addToBill(change.doc, 'bills')
                        }
                    })
                })
            },

            getArchiveBills () {
                let companyId = this.$store.getters.getCompanyID;
                const firestore = firebase.firestore();
                let archievedBills = firestore.collection('company').doc(companyId).collection('archivedBills')
                                                          .orderBy('archivedOn', 'desc')
                                                          .where('archivedOn', '>=', this.periodFilter.from)
                                                          .where('archivedOn', '<=', this.periodFilter.to)
                                                          .limit(this.limit)
                
                this.archiveListener = archievedBills.onSnapshot((snapshot) => {
                    snapshot.docChanges().forEach(change => {
                        if (change.type === "added") {
                            this.addToBill(change.doc, 'archievedBills')
                        }
                    })
                })
            },

            addToBill(doc, dest) {
                let billData = doc.data()
                this[dest].push({
                    tableNumber: billData.table ? billData.table.number.toString() : `DELIVERY: ${billData.startingFrom}`,
                    qtyCustomers: Object.keys(billData.usersOrders).length,
                    ...billData, 
                })
            },

            update (tabIndex) {
                const { tabConfig, periodFilter } = this;
                const tab = tabConfig[tabIndex];
                if (!tab || hash(tab.loaded) == hash(periodFilter))
                    return;
                tabConfig[tabIndex].loaded = hash(periodFilter);
                if (this[tab.listener]) {
                    this[tab.listener]();
                }
                this[tab.coisa] = [];
                this[tab.action](); // todo use store
            },

            filter (filter) {
                this.busy = true;
                this.periodFilter.from = filter.date.from;
                this.periodFilter.to = filter.date.to;
                this.update(this.activeTab);
                setTimeout(() => this.busy = false, 1200)
            }
        }
    }
</script>